import { makeStyles, tokens } from '@fluentui/react-components';
import React, { Suspense } from "react"
import { useIntl } from 'react-intl';

import { useDocumentTitle } from '@tdp/common/shared';

import { AppListPageSkeleton } from "../components/AppListSkeleton";
import AppListTable from "../components/AppListTable";

const useStyles = makeStyles({
  pageContainer: {
    backgroundColor: tokens.colorNeutralBackground1,
    color: tokens.colorBrandBackgroundInverted,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    boxSizing: 'border-box',
    height: '100%',
    width: '100%',
    overflowY: 'auto',
  },
})

const AppListPageLoader: React.FC = () => {
  return (
    <Suspense fallback={<AppListPageSkeleton />}>
      <AppListTable />
    </Suspense>
  );
}

export const AppListPage: React.FC = () => {
  const classes = useStyles();
  const intl = useIntl();
  useDocumentTitle(intl.formatMessage({ defaultMessage: "Apps", description: "Apps page title" }));

  return (
    <div className={classes.pageContainer}>
      <AppListPageLoader />
    </div>
  );
};